/**
 * Extracts and parses query parameters from query object
 * @param {{ query: Record<string, string | string[]> }} params The params with query object
 * @returns {Record<string, string>} An object containing the query parameters as key-value pairs.
 */

export const getUrlParameters = (
  params: Record<string, Date | string | string[]>,
): Record<string, string> => {
  const parameters = params;
  const parsedParameters: Record<string, string> = {};

  Object.keys(parameters).forEach(key => {
    const value = parameters[key];

    if (typeof value === 'string') {
      parsedParameters[key] = value;
    }
  });

  return parsedParameters;
};
